import { render, staticRenderFns } from "./FaultSummaryCard.vue?vue&type=template&id=12e739a6"
import script from "./FaultSummaryCard.vue?vue&type=script&lang=js"
export * from "./FaultSummaryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports